<div class="popup-container tlms-popup">
    <header>
        <div class="header" style="display:block"> {{heading}}</div>
        <button class="close" style="top:-3px" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </header>
    <div class="body" style="padding: 16px 24px 16px 24px;">
        <div class="form-row" style="display: flex; justify-content: center; align-items: flex-start;">
            <div class="form-col" style="display: flex; flex-direction: column; width: 100%;">
                <label class="catlabel">
                    Period<span style="color:#ff0000">*</span>
                </label>
                <mat-form-field appearance="outline" class="fixed-select" subscriptSizing="dynamic" style="width: 100%;">
                    <mat-select [(ngModel)]="selected_period_id" placeholder="Select">
                        <mat-option>
                            <ngx-mat-select-search [formControl]="periodFilterCtrl" placeholderLabel="Search"
                                noEntriesFoundLabel="No results found">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let period of filteredPeriods | async" [value]="period">
                            {{ period.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="form-row" style="display: flex; justify-content: center; align-items: flex-start;">
            <div class="form-col" style="display: flex; flex-direction: column; width: 100%;">
                <label class="catlabel">Reason<span style="color:#ff0000">*</span></label>
                <mat-form-field appearance="outline" class="fixed-select" style="width: 100%;">
                    <mat-select [(ngModel)]="selectedResonIds" placeholder="Select">
                        <mat-option>
                            <ngx-mat-select-search [formControl]="reasonFilterCtrl" placeholderLabel="Search"
                                noEntriesFoundLabel="No results found">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let reason of filteredReasons | async" [value]="reason">
                            {{ reason.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="form-row" style="display: flex; justify-content: center; align-items: flex-start;">
            <div class="form-col" style="display: flex; flex-direction: column; width: 100%;">
                <label class="catlabel">Domicile<span style="color:#ff0000">*</span></label>
                <mat-form-field appearance="outline" class="fixed-select" style="width: 100%;">
                    <mat-select [(ngModel)]="selectedDomiciles" [multiple]="true" placeholder="Select">
                        <div
                            style="display: flex; align-items: center; position: sticky; top: 0; background: white; z-index: 1;">

                            <mat-checkbox style="margin-right: 0px;" [checked]="isAllSelected()"
                                [indeterminate]="isIndeterminate()" (change)="toggleSelectAll($event)">
                            </mat-checkbox>
                            <mat-option>
                                <ngx-mat-select-search [formControl]="domicileFilterCtrl" placeholderLabel="Search"
                                    noEntriesFoundLabel="No results found">
                                </ngx-mat-select-search>
                            </mat-option>
                        </div>
                        <mat-option *ngFor="let d of filteredDomiciles | async" [value]="d">
                            {{ d.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
    <label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label>
    <label *ngIf="successmsg" class="successmsg"> {{successmsg}} </label>
    <div class="cfooter d-flex justify-content-between align-items-center popup-footer">
        <button (click)="onNoClick()" class="mCancel"> CANCEL</button>
        <button mat-raised-button class="black-btn" style="display: inline;" (click)="saveClick()">SUBMIT</button>
    </div>
</div>